import Vue from 'vue'
import HelloWorld from './HelloWorld.vue'

Vue.component('onepipe-checkout', HelloWorld);

export default { HelloWorld}
